export class JumpToAnchor {
  constructor (settings = {}) {
    this.options = $.extend({
      selectors: {
        toTop: '.btn--to-top, .btn--to-top-fixed',
        anchor: 'a[href*="#"][href*="' + window.location.host + '"],a[href^="/"][href*="#"]:not([href^="//"]),a[href^="#"]',
        pageHeader: '.page-header'
      },
      classes: {
        bodyHeaderScrolling: 'is--header-scrolling',
        bodyOnScrolling: 'is--btn-to-top'
      },
      scrollTime: 2000,
      additionalOffsetTop: 10,
      ticking: false,
      scrollBreakpoint: 0.9
    },
    settings)
  }

  init () {
    this.addEvents()
  }

  addEvents () {
    const that = this

    $(that.options.selectors.toTop)
      .on({
        click: function (event) {
          event.preventDefault()

          that.jumpToTop()
        }
      })

    $(that.options.selectors.anchor)
      .on({
        click: function (event) {
          const element = $(this)
          const hash = element.attr('href').substring(element.attr('href').indexOf('#'))

          if (hash.length > 1) {
            const targetElement = document.querySelector(hash)

            if (targetElement) {
              event.preventDefault()

              that.jumpToElement(targetElement)
            }
          }
        }
      })

    that.addIsHeaderScrolling(window.scrollY)
    $(document).on('scroll', function () {
      const lastKnowScrollPosition = window.scrollY

      if (!that.ticking) {
        window.requestAnimationFrame(function () {
          that.addIsHeaderScrolling(lastKnowScrollPosition)
          that.ticking = false
        })
      }

      that.ticking = true
    })
  }

  jumpToTop () {
    const that = this

    $('html, body')
      .animate({
        scrollTop: 0
      }, that.options.scrollTime)
  }

  jumpToElement (target) {
    let element = target

    if (target instanceof jQuery) {
      if (target.length === 0) return
      element = target[0]
    }

    if (element instanceof Element) {
      const y = (element.getBoundingClientRect().top + window.scrollY) - this.calculateHeaderOffset()

      window.scrollTo({ top: y, behavior: 'smooth' })
    }
  }

  calculateHeaderOffset () {
    const that = this
    let calculatedOffset = 0

    if ($(that.options.selectors.pageHeader).length > 0) {
      if ($('body').hasClass(that.options.classes.bodyHeaderScrolling)) {
        calculatedOffset = $(that.options.selectors.pageHeader).outerHeight() + that.options.additionalOffsetTop
      } else {
        $('body').addClass(that.options.classes.bodyHeaderScrolling)
        calculatedOffset = $(that.options.selectors.pageHeader).outerHeight() + that.options.additionalOffsetTop
        $('body').removeClass(that.options.classes.bodyHeaderScrolling)
      }
    }

    return calculatedOffset
  }

  addIsHeaderScrolling (scrollPosition) {
    const halfTheScreenHeight = window.innerHeight / this.options.scrollBreakpoint
    const scrollTillEnd = (($(document).height() - $(window).innerHeight()) - scrollPosition)

    if (scrollPosition >= halfTheScreenHeight) {
      if (scrollTillEnd > 250) {
        $('body').addClass(this.options.classes.bodyOnScrolling)
      } else if (scrollTillEnd < 150) {
        $('body').removeClass(this.options.classes.bodyOnScrolling)
      }
    } else {
      $('body').removeClass(this.options.classes.bodyOnScrolling)
    }
  }
}

export default JumpToAnchor
